import { render } from "./OCRWords.vue?vue&type=template&id=13edb8a0&scoped=true&ts=true"
import script from "./OCRWords.vue?vue&type=script&lang=ts"
export * from "./OCRWords.vue?vue&type=script&lang=ts"

import "./OCRWords.vue?vue&type=style&index=0&id=13edb8a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13edb8a0"]])

export default __exports__